import { render, staticRenderFns } from "./PixelBase.vue?vue&type=template&id=64e47db9&"
import script from "./PixelBase.vue?vue&type=script&lang=js&"
export * from "./PixelBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports